import React, { ReactNode } from 'react';

import useProductsV2AndGqlProducts from '../hooks/useProductsV2AndGqlProducts';

import SlicedGridProvider from './SlicedGridProvider';

interface ProductsV2ProviderProps {
  children: ReactNode;
}

export const ProductsV2Provider = ({ children }: ProductsV2ProviderProps) => {
  const productsV2Data = useProductsV2AndGqlProducts();

  return (
    <SlicedGridProvider data={productsV2Data}>{children}</SlicedGridProvider>
  );
};
